import { isFieldForListingType } from '../../util/fieldHelpers';

export function getListingFields({ publicData, metadata = {}, listingFieldConfigs, isFieldForCategory }) {
    if (!publicData || !listingFieldConfigs) return [];

    const result = [];

    for (const config of listingFieldConfigs) {
        const { key, schemaType, enumOptions } = config;

        const listingType = publicData.listingType;
        const isTargetListingType = isFieldForListingType(listingType, config);
        const isTargetCategory = isFieldForCategory(config);
        const value = publicData[key] ?? metadata[key];

        if (isTargetListingType && isTargetCategory && value) {
            let selectedOptions = [];

            if (schemaType === 'multi-enum' && Array.isArray(enumOptions)) {
                selectedOptions = enumOptions
                    .filter(option => value.includes(option.option))
                    .map(option => ({ label: option.label, option: option.option }));
            }

            if (selectedOptions.length > 0) {
                result.push({ key, value: selectedOptions });
            }
        }
    }

    return result;
}
